var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4121 14.2102C10.5782 12.3446 10.9524 10.2779 11.7034 8.49769C12.2598 7.17867 12.985 6.10917 13.8973 5.37567C14.7809 4.66537 15.9269 4.19766 17.498 4.19766C19.0691 4.19766 20.2152 4.66537 21.0988 5.37567C22.0111 6.10917 22.7363 7.17867 23.2927 8.49769C24.0437 10.2779 24.4179 12.3446 24.584 14.2102H10.4121ZM6.79929 14.2102C6.97259 12.0114 7.40706 9.42004 8.38646 7.09842C9.09564 5.41731 10.1283 3.78661 11.6417 2.56994C13.184 1.33008 15.1316 0.597656 17.498 0.597656C19.8644 0.597656 21.8121 1.33008 23.3544 2.56994C24.8678 3.78661 25.9005 5.41731 26.6096 7.09842C27.589 9.42004 28.0235 12.0114 28.1968 14.2102H29.8734C32.483 14.2102 34.5984 16.3256 34.5984 18.9352V34.6852C34.5984 37.2947 32.483 39.4102 29.8734 39.4102H5.12344C2.51389 39.4102 0.398438 37.2947 0.398438 34.6852V18.9352C0.398438 16.3256 2.51389 14.2102 5.12344 14.2102H6.79929ZM18.8484 26.2414C19.6557 25.7746 20.1988 24.9019 20.1988 23.9023C20.1988 22.4112 18.99 21.2023 17.4988 21.2023C16.0077 21.2023 14.7988 22.4112 14.7988 23.9023C14.7988 24.9016 15.3416 25.774 16.1484 26.2409V30.6539C16.1484 31.3995 16.7529 32.0039 17.4984 32.0039C18.244 32.0039 18.8484 31.3995 18.8484 30.6539V26.2414Z",
    fill: "#54C68F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressing);
export default __webpack_public_path__ + "static/media/progressing.fc95bfd9909023e4474ba9e8e57938a0.svg";
export { ForwardRef as ReactComponent };